import { render, staticRenderFns } from "./ConferenceRoom.vue?vue&type=template&id=88b95524&scoped=true&"
import script from "./ConferenceRoom.vue?vue&type=script&lang=js&"
export * from "./ConferenceRoom.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceRoom.vue?vue&type=style&index=0&id=88b95524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b95524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VProgressCircular,VRow})
